import { getDefaultAuthenticatedPath } from './authRedirect';
import type { AuthRole } from './authRedirect';

export type AccountAwarePlanKind =
  | 'worker-free'
  | 'worker-automation'
  | 'employer-plan';

type AccountAwarePlanCtaInput = {
  isAuthenticated: boolean;
  role?: AuthRole;
  kind: AccountAwarePlanKind;
  signedOutLabel: string;
  signedOutPath: string;
};

export type AccountAwarePlanCta = {
  label: string;
  path: string;
};

const accountHomeLabel = (role?: AuthRole) => {
  if (role === 'worker') return 'Go to Worker Dashboard';
  if (role === 'employer') return 'Go to Employer Dashboard';
  if (role === 'admin') return 'Go to Admin Dashboard';
  return 'Open StageCrew';
};

/**
 * Keeps public plan cards useful without sending an existing account back
 * through registration or implying that a plan has already been selected.
 */
export const getAccountAwarePlanCta = ({
  isAuthenticated,
  role,
  kind,
  signedOutLabel,
  signedOutPath,
}: AccountAwarePlanCtaInput): AccountAwarePlanCta => {
  if (!isAuthenticated) {
    return { label: signedOutLabel, path: signedOutPath };
  }

  if (role === 'worker') {
    if (kind === 'worker-free') {
      return { label: 'Browse Jobs', path: '/jobs' };
    }
    if (kind === 'worker-automation') {
      return {
        label: 'View Automation Early Access',
        path: '/subscription',
      };
    }
  }

  if (role === 'employer' && kind === 'employer-plan') {
    return {
      label: 'View Employer Plans',
      path: '/employer/subscription',
    };
  }

  return {
    label: accountHomeLabel(role),
    path: getDefaultAuthenticatedPath(role),
  };
};
